{
    "TelephoneserverLabel": "Servidor de telefone:",
    "PartitionsLabel": "Partições:",
    "ScopeFiltering_SectionHeader": "Filtragem de Escopo",
    "NAME": "ScopeFiltering",
    "ScopeGroupsLabel": "Grupo(s) de Escopo:",
    "AnyScopeGroupsLabel": "[Qualquer Grupo de Escopo]"
}